import { FC, ReactNode } from "react"

import { formatFiatCurrency } from "../../util/formatter"

interface NumberFieldProps {
  id: string
  label: string
  value: number
  onChange: (value: string) => void
  disabled?: boolean
  hint?: string
  placeholder?: string
  centsDisplay?: boolean
  currencyCode?: string
  suffix?: ReactNode
}

export const NumberField: FC<NumberFieldProps> = ({
  id,
  label,
  value,
  onChange,
  disabled,
  hint,
  placeholder,
  centsDisplay,
  currencyCode,
  suffix
}) => (
  <div className="flex flex-col gap-2 px-4 py-3 border rounded-lg border-black/10 dark:border-white/10 bg-white dark:bg-[#0C0C1A]">
    <div className="flex flex-row justify-between items-center">
      <label className="text-base font-medium text-gray-800 dark:text-white" htmlFor={id}>
        {label}
      </label>
      {centsDisplay && (
        <span className="text-sm text-gray-500 dark:text-gray-400">{formatFiatCurrency(value, "0.00$", currencyCode)}</span>
      )}
      {suffix}
    </div>
    <input
      id={id}
      type="number"
      min={0}
      className="input input-bordered w-full px-3 py-2 text-sm rounded-lg bg-white text-black border-black/10 placeholder:text-gray-400 dark:bg-[#0C0C1A] dark:text-white dark:border-white/10"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      placeholder={placeholder}
    />
    {hint && <span className="text-xs text-gray-400">{hint}</span>}
  </div>
)
